import React, { Component } from "react";
import {  Loader, Icon, Message, Pagination, Modal, Form, Table, Button, Divider, Header, Tab} from 'semantic-ui-react'
import { invokeApig, downloadS3Text, uploadS3Text, listS3objects, uploadS3 } from "../libs/awsLib";
import config from "../config";
import _ from 'lodash';
import { FilePond, registerPlugin } from 'react-filepond';  
import 'filepond/dist/filepond.min.css';

const PAGE_SIZE=20;
const NO_PAGES=100;

export default class FirmwareVersions extends Component {
  constructor(props) {
    super(props);

    
    this.state={firmwareData: {'firmwareimages':[], 'upgradepaths': []}, manufacturer: 'All', model: '', activeVersionPage: 1, activeImagePage: 1, firmwareversion: '', actions: {'AutomatedUpgrade': 'Automated Upgrade', 'ManualUpgrade': 'Manual Upgrade', 'None': 'None'}, showAddModal: false, manufacturers: [], manufacturersFilter: [], manufacturerLookup: {}, loading: true, uploadSuccess: false, uploadFailed: false, validationErrors: [], addManufacturer: '', addModel: '', addFirmwareVersion: '', addUpgradeImage: '', addAction: 'None', imageName: '', firmwareImages: {}, showUploadModal: false};

  }


  
  componentDidMount()
  {
    this.loadManufacturers();
    this.loadContent();
    this.loadFirmwareImages();
    
    
  }

  loadFirmwareImages() {

    listS3objects(config.smartAdapterS3Bucket, 'firmware/').then((results)=>
    {
      var firmwareImages={};
      results.forEach(result=>{
        const parseKey=result.Key.split('/');
        if (parseKey.length>=2)
          if (!(parseKey[1] in firmwareImages))
            firmwareImages[parseKey[1]]={};  
        
        if (parseKey.length===3) {
        if (parseKey[2].endsWith('.ota'))
          firmwareImages[parseKey[1]]['otaHeaderFile']=parseKey[2]
        if (parseKey[2].endsWith('.mi'))
          firmwareImages[parseKey[1]]['imageFile']=parseKey[2]

        }})
      this.setState({firmwareImages: firmwareImages})
    })
  }

  loadManufacturers=()=>
  {
    // invokeApig({path: '/lookups/smartdevicemanufacturer', method: "GET",  body: null}).then((results)=>
    // {
    //   var manufacturers=[{key: 'All', value: 'All', text: 'All'}];
    //   var manufacturerLookup={};
    //   var sortResults=_.sortBy(results.data, ['text'])
    //   sortResults.forEach(manufacturer=>{manufacturers.push(manufacturer); manufacturerLookup[manufacturer.key]=manufacturer.text});
  
    //     this.setState({manufacturers: manufacturers, manufacturerLookup: manufacturerLookup});
    // })
    
      var manufacturerLookup={'1015': 'Flonidan', '1031': 'Secure Meters (UK) Limited', '1057': 'Elster GmbH', '1063': 'Landis + Gyr', '106C': 'EDMI Europe Limited', '1072': 'Wistron NeWeb Corp', '1086': 'Toshiba', '1090': 'Green Energy Options Ltd', '10C7': 'Trilliant', '1125': 'Kaifa', '118F': 'Aclara', '1192': 'George Wilson Industries Ltd', '123E': 'Flonidan', '5401': 'Wistron NeWeb Corp'};
      var manufacturersFilter=[{key: 'All', value: 'All', text: '(All)'}];
      var manufacturers=[];
      Object.keys(manufacturerLookup).forEach(key=>{manufacturersFilter.push({key: key, value: key, text: manufacturerLookup[key] + ' ('+key+')'}); manufacturers.push({key: key, value: key, text: manufacturerLookup[key] + ' ('+key+')'})})
      manufacturers=_.sortBy(manufacturers, ['text'])
      this.setState({manufacturers: manufacturers, manufacturersFilter: manufacturersFilter, manufacturerLookup: manufacturerLookup});
  }

  loadContent()
  {
    const bucket=config.awsEnv+'.sgserve.config';
    const key=config.stage+'/firmware.json'
    downloadS3Text(bucket, key).then(result=>{console.log(result); this.setState({firmwareData: result, loading: false})})
  }
  saveContent()
  {
    const bucket=config.awsEnv+'.sgserve.config';
    const key=config.stage+'/firmware.json'
    //update json 
    uploadS3Text(bucket, key, this.state.firmwareData).then(result=>{this.setState({uploadSuccess: true, uploadFailed: false, validationErrors: []})}).catch(result=>{this.setState({uploadSuccess: false, uploadFailed: true, validationErrors: ['Failed to save confguration']})})
  }

  filterVersions=(version)=>{
    return (this.state.manufacturer==="All" || version.devicemanufacturer===this.state.manufacturer) && (this.state.model==="" || version.devicemodel.startsWith(this.state.model)) && (this.state.firmwareversion==="" || version.firmwareversion.startsWith(this.state.firmwareversion))
  }

  filterImages=(image)=>{
    return (this.state.imageName==="" || image.startsWith(this.state.imageName))
  }

  setFirmwareAction(rowIndex, action)
  {
    var copyData=_.cloneDeep(this.state.firmwareData);
    copyData.upgradepaths[rowIndex].action=action;
    this.setState({firmwareData: copyData});
  }
  addFirmwareUpgradePath()
  {
    var copyData=_.cloneDeep(this.state.firmwareData);
    copyData.upgradepaths.push({devicemanufacturer: this.state.addManufacturer, devicemodel: this.state.addModel, firmwareversion: this.state.addFirmwareVersion, upgradeimage: this.state.addUpgradeImage, action: this.state.addAction})
    this.setState({firmwareData: copyData});
  }

  addFirmwareImage() {
    const imageName=prompt("Image name");
    if (imageName.length>0)
    {
      var copyData=_.cloneDeep(this.state.firmwareImages);
      copyData[imageName]={};
      this.setState({firmwareImages: copyData})
    }
  }

 render() {

    
    //handle pagination
    var activeVersionPage=this.state.activeVersionPage;
    var firmwareVersions=this.state.firmwareData.upgradepaths.filter(this.filterVersions);
    if (firmwareVersions.length<(activeVersionPage-1)*PAGE_SIZE)
    {
      activeVersionPage=1;
      this.setState({activeVersionPage: 1})
    }
    firmwareVersions=firmwareVersions.slice((activeVersionPage-1)*PAGE_SIZE, activeVersionPage*PAGE_SIZE)
    
    var activeImagePage=this.state.activeImagePage;
    var firmwareImages=Object.keys(this.state.firmwareImages).filter(this.filterImages);
    if (firmwareImages.length<(activeImagePage-1)*PAGE_SIZE)
    {
      activeImagePage=1;
      this.setState({activeImagePage: 1})
    }
    firmwareImages=firmwareImages.slice((activeImagePage-1)*PAGE_SIZE, activeImagePage*PAGE_SIZE)

    var _this=this;
    const serveroptions={
      process: function(fieldName, file, metadata, load, error, progress, abort) 
      {
        const filename=file.name.replace(/[()]/g, '')
        const s3key='firmware/' + _this.state.uploadImageName + '/' +_this.state.uploadImageName+'.'+_this.state.fileType;
        uploadS3(config.smartAdapterS3Bucket, s3key, file).then(response=>{
          _this.loadFirmwareImages();
          load(filename)

          })
        }
      } 

    if (this.state.loading)
      return <Loader/>
    else 
    {
    const panes = [
      { menuItem: {key: 'Upgrade Paths', content: 'Upgrade Paths', icon: 'fork'}, render: () => <Tab.Pane><div>
      <Modal open={this.state.showAddModal}>
        <Modal.Header size='tiny'>
        <h3 className="seaglassblue"><Icon circular className="seaglassblue" name="add"/>Add Firmware Upgrade Path</h3>
        </Modal.Header>  
        <Modal.Content>
        <Form>
        <Form.Select label="Manufacturer" placeholder="Manufacturer" required options={this.state.manufacturers} value={this.state.addManufacturer} onChange={(event, data)=>{this.setState({addManufacturer: data.value})}}/>
        <Form.Input label="Model" placeholder="Model" length={8} required value={this.state.addModel} onChange={(event, data)=>{this.setState({addModel: data.value})}}/>
        <Form.Input label="Firmware Version" placeholder="Model" length={8} required value={this.state.addFirmwareVersion} onChange={(event, data)=>{this.setState({addFirmwareVersion: data.value})}}/>
        <Form.Select label="Upgrade Image" placeholder="Upgrade Image" required value={this.state.addUpgradeImage} options={this.state.firmwareData.firmwareimages.map(upgradeImage=>{return {key: upgradeImage, value: upgradeImage, text: upgradeImage}})} onChange={(event, data)=>{this.setState({addUpgradeImage: data.value})}}/>
        <Form.Select label="Action" placeholder="Action" required value={this.state.addAction} options={Object.keys(this.state.actions).map(key=>{return {key: key, value: key, text: this.state.actions[key]}})} onChange={(event, data)=>{this.setState({addAction: data.value})}}/>
        <Divider/>
        {this.state.components && <Button className="seaglassbutton" disabled={!this.state.formValid || this.state.submitSuccess} loading={this.state.isExecuting} onClick={this.executeFunction}>Save</Button>}
        <Button className='seaglassbutton' disabled={(!this.state.addManufacturer || !this.state.addModel || !this.state.addUpgradeImage || !this.state.addFirmwareVersion)} onClick={()=>this.addFirmwareUpgradePath()}>Add</Button>
        <Button className="seaglassbutton" onClick={()=>this.setState({showAddModal: false, addManufacturer: '', addModel: '', addFirmwareVersion: '', addUpgradeImage: '', addAction: 'None'})}>Close</Button>
        </Form>
        </Modal.Content>
        </Modal>       
        <Form inverted={this.state.darkmode}>
        <Form.Group inline>
        <label style={{color: this.props.darkmode ? "white": "black"}}>Manufacturer</label>
        <Form.Select placeholder='Manufacturer' options={this.state.manufacturersFilter} value={this.state.manufacturer} onChange={(event, data)=>{this.setState({manufacturer: data.value}); }} />
        <label style={{color: this.props.darkmode ? "white": "black"}}>Model</label>
        <Form.Input placeholder='Model' value={this.state.model} onChange={(event, data)=>{this.setState({model: data.value}); }} />
        <label style={{color: this.props.darkmode ? "white": "black"}}>Version</label>
        <Form.Input placeholder='Version' value={this.state.firmwareversion} onChange={(event, data)=>{this.setState({firmwareversion: data.value}); }} />

        <Button className='seaglassbutton' onClick={()=>{this.setState({showAddModal: true})}}><Icon name='add'/>Add</Button>
        </Form.Group>
      </Form>
      <Table>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Manufacturer</Table.HeaderCell>
          <Table.HeaderCell>Model</Table.HeaderCell>
          <Table.HeaderCell>Firmware Version</Table.HeaderCell>
          <Table.HeaderCell>Upgrade Image</Table.HeaderCell>
          <Table.HeaderCell>Action</Table.HeaderCell>
        </Table.Row>
        </Table.Header>
        <Table.Body>
        {firmwareVersions.map((version, i)=>{
          return <Table.Row>
            <Table.Cell>{version.devicemanufacturer in this.state.manufacturerLookup ? this.state.manufacturerLookup[version.devicemanufacturer] : version.devicemanufacturer}</Table.Cell>
            <Table.Cell>{version.devicemodel}</Table.Cell>
            <Table.Cell>{version.firmwareversion}</Table.Cell>
            <Table.Cell>{version.upgradeimage}</Table.Cell>
            <Table.Cell><Form.Select placeholder='Action' value={version.action} options={Object.keys(this.state.actions).map(key=>{return {key: key, value: key, text: this.state.actions[key]}})} onChange={(event, data)=>{this.setFirmwareAction(i, data.value); }} /></Table.Cell>
            </Table.Row>
        })}
        </Table.Body>
        </Table>
        <Divider/>
        <Pagination activeVersionPage={this.state.activeVersionPage} totalPages={Math.ceil(this.state.firmwareData.upgradepaths.length/PAGE_SIZE)} onPageChange={(event, { activeVersionPage })=>{this.setState({activeVersionPage: activeVersionPage})}}/> 
        {this.state.uploadFailed && <Message error header="Failed to save firmware upgrade paths" list={this.state.validationErrors}/>}
        {this.state.uploadSuccess && <Message success header="Firmware upgrade paths successfully saved"/>}
        <Button className='seaglassbutton' onClick={()=>this.saveContent()}>Save</Button>
        <Button className='seaglassbutton' onClick={()=>this.loadContent()}>Reset</Button>
      </div>
        </Tab.Pane> },
      { menuItem: {key: 'Firmware Images', content: 'Firmware Images', icon: 'images'}, render: () => <Tab.Pane>
        
        <Form inverted={this.state.darkmode}>
        <Form.Group inline>
        <label style={{color: this.props.darkmode ? "white": "black"}}>Image Name</label>
        <Form.Input placeholder='Image Name' value={this.state.imageName} onChange={(event, data)=>{this.setState({imageName: data.value}); }} />

        <Button className='seaglassbutton' onClick={()=>{this.addFirmwareImage()}}><Icon name='add'/>Add</Button>
        </Form.Group>
      </Form>
      <Table collapsing>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Image Name</Table.HeaderCell>
          <Table.HeaderCell colSpan={2}>OTA Header File</Table.HeaderCell>
          <Table.HeaderCell colSpan={2}>Image File</Table.HeaderCell>
        </Table.Row>
        </Table.Header>
        <Table.Body>
        {firmwareImages.map((imageName, i)=>{
          return <Table.Row>
            <Table.Cell>{imageName}</Table.Cell>
            <Table.Cell>{this.state.firmwareImages[imageName].otaHeaderFile ? this.state.firmwareImages[imageName].otaHeaderFile : <span><Icon color="red" name="exclamation"/>Missing</span>}</Table.Cell>
            <Table.Cell><Button className='seaglassbutton' onClick={()=>{this.setState({showUploadModal: true, uploadImageName: imageName, fileType: 'ota'})}}><Icon name='upload'/>Upload</Button></Table.Cell>
            <Table.Cell>{this.state.firmwareImages[imageName].imageFile ? this.state.firmwareImages[imageName].imageFile : <span><Icon color="red" name="exclamation"/>Missing</span>}</Table.Cell>
            <Table.Cell><Button className='seaglassbutton' onClick={()=>{this.setState({showUploadModal: true, uploadImageName: imageName, fileType: 'mi'})}}><Icon name='upload'/>Upload</Button></Table.Cell>
            </Table.Row>
        })}
        </Table.Body>
        </Table>
        <Divider/>
        <Pagination activeImagePage={this.state.activeImagePage} totalPages={Math.ceil(firmwareImages.length/PAGE_SIZE)} onPageChange={(event, { activeImagePage })=>{this.setState({activeImagePage: activeImagePage})}}/> 
        <Modal closeIcon open={this.state.showUploadModal} onClose={()=>{this.setState({showUploadModal: false})}}>
        <Modal.Header size='tiny'>
        <h3 className="seaglassblue"><Icon circular className="seaglassblue" name="add"/>Upload Firmware Image File</h3>
        </Modal.Header>  
        <Modal.Content>
        <FilePond allowMultiple={true} allowRevert={false} server={serveroptions} />
        </Modal.Content>
        </Modal> 
      </Tab.Pane> },

    ]
      return (
        <div className="fullpagetab">
      <Tab menu={{tabular: true, attached: 'top' }} panes={panes}  />
      </div>
      );  
    }
      return 

  
    }
  }